import { render, staticRenderFns } from "./modal_edit_news_trend.vue?vue&type=template&id=33d2c9d2&scoped=true"
import script from "./modal_edit_news_trend.vue?vue&type=script&lang=js"
export * from "./modal_edit_news_trend.vue?vue&type=script&lang=js"
import style0 from "./modal_edit_news_trend.vue?vue&type=style&index=0&id=33d2c9d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d2c9d2",
  null
  
)

export default component.exports